import { useEffect, useState } from 'react';

import { PermissionContext } from 'src/contexts';
import {
  INITIAL_PERMISSION,
  IPermissionContext,
} from 'src/contexts/permission.context/permission.context.model';

import { useSupportAuth } from 'src/hooks/support-auth.hook';
import { useGetCurrentAccount } from 'src/hooks/accounts/get-current-account.hook';
import { useGetCurrentPermissionGroup } from 'src/hooks/permission-group/get-current-permission-group.hook';

const PermissionContextProvider: React.FC = props => {
  const [permissionState, setPermissionState] = useState<IPermissionContext>(INITIAL_PERMISSION);
  const { permissionGroupId, permissions, loading } = useGetCurrentPermissionGroup();
  const { account } = useGetCurrentAccount();

  useEffect(() => {
    if (permissions.length) {
      setPermissionState({ accountId: account._id, permissionGroupId, permissions });
    }
  }, [permissions, permissionGroupId, account._id]);

  useSupportAuth();

  return (
    <PermissionContext.Provider value={permissionState}>
      {loading ? null : props.children}
    </PermissionContext.Provider>
  );
};

export default PermissionContextProvider;
